import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18n from './translation/i18n';
import { I18nextProvider } from 'react-i18next';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AppProvider } from './contexts/app.context';
import { ConfigProvider } from 'antd';
import lightTheme from './theme';
import * as Sentry from '@sentry/react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
});

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: false,
    integrations: [],
    environment: process.env.NODE_ENV,
    release: 'inter-client-app'
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <I18nextProvider i18n={i18n}>
          <ConfigProvider
            getPopupContainer={() => document.getElementById('root')!}
            // componentSize='small'
            theme={lightTheme}
            form={{ colon: false }}
          >
            <App />
          </ConfigProvider>
        </I18nextProvider>
      </AppProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.register();
